module.exports = __webpack_public_path__ + "media/2.2_tabla_11_cf1.40a92d67.wav";